import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { NAMES } from 'cio/utils/ad-audiences';
import { AdNetworkType } from 'cio/utils/ad-audiences';

export interface AudienceCredentialAdAccount {
  name: string;
  accountId: string;
  nameWithId: string;
}

export interface AudienceCredentialTypeDetail {
  adAccounts: AudienceCredentialAdAccount[];
}

export default class AudienceCredentialModel extends Model {
  @attr('string') type!: AdNetworkType;
  @attr('json') json!: unknown;
  @attr('boolean') expired!: boolean;
  @attr('audience-credential/type-detail', { defaultValue: () => ({}), type: 'facebook' } as any)
  facebook!: AudienceCredentialTypeDetail;
  @attr('audience-credential/type-detail', { defaultValue: () => ({}), type: 'adwords' } as any)
  adwords!: AudienceCredentialTypeDetail;
  @attr('number') createdAt!: number;
  @attr('number') updatedAt!: number;

  get adNetworkName() {
    return NAMES[this.type];
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'audience-credential': AudienceCredentialModel;
  }
}
